import { z } from 'zod';
import type { REVIEW_DECISION } from './reviewDecision.constants';
import { REVIEWER_COMMENT_MAX_LENGTH } from './reviewDecision.constants';

const reviewerCommentSchema = z
  .string()
  .trim()
  .max(
    REVIEWER_COMMENT_MAX_LENGTH,
    `Comment must be ${REVIEWER_COMMENT_MAX_LENGTH} characters or fewer`,
  );

export const approveReviewSchema = z.object({ comment: reviewerCommentSchema });

export const rejectReviewSchema = z.object({
  comment: reviewerCommentSchema.min(1, 'A comment is required'),
});

export type ReviewDecision = (typeof REVIEW_DECISION)[keyof typeof REVIEW_DECISION];
export type ReviewPayload = z.infer<typeof approveReviewSchema>;
